import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Table,
  ProgressBar,
  Modal,
} from "react-bootstrap";
import axios from "axios";
import toast from 'react-hot-toast';
const BASE_URL = process.env.REACT_APP_BASE_URL || "";

// ✅ Utility to format file size
const humanFileSize = (bytes) => {
  if (bytes === 0) return "0 B";
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
};

const Brochure = () => {
  const [file, setFile] = useState(null);
  const [list, setList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [confirmDelete, setConfirmDelete] = useState({ show: false, id: null });
  const inputRef = useRef();


  // ✅ File selection
  const onFileSelect = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    if (f.type !== "application/pdf") {
      toast.error("Only PDF files allowed");
      return;
    }
    setFile(f);
  };

  // ✅ Drag & Drop
  const handleDrop = (e) => {
    e.preventDefault();
    const f = e.dataTransfer.files[0];
    if (!f) return;
    if (f.type !== "application/pdf") {
      toast.error("Only PDF files allowed");
      return;
    }
    setFile(f);
  };

  const handleDragOver = (e) => e.preventDefault();

  // ✅ Upload
  const handleUpload = async () => {
    if (!file) {
      toast.error("Select a PDF first");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("uploaded_by", "admin"); // optional metadata

    try {
      setUploading(true);
      setProgress(0);

      await axios.post(`${BASE_URL}/api/superadmin/brochure`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (p) => {
          const percent = Math.round((p.loaded * 100) / p.total);
          setProgress(percent);
        },
      });

      toast.success("Uploaded successfully");
      setFile(null);
      inputRef.current.value = "";
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Upload failed");
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  // ✅ Download
  const handleDownload = (id) => {
    window.open(`${BASE_URL}/api/brochure/${id}/download`, "_blank");
  };

  return (
    <Container fluid className="py-4">
  

      {/* Page Heading */}
      <Row className="mb-4">
        <Col xs={12}>
          <h2 className="global-heading">Brochure Upload</h2>
        </Col>
      </Row>

      <Row>
        {/* Upload Section */}
        <Col lg={10}>
          <Card className="p-3 mb-4">
            <h5 className="mb-3">Upload Brochure (PDF)</h5>

            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              className="d-flex flex-column align-items-stretch p-3"
              style={{
                border: "2px dashed var(--border-main)",
                borderRadius: "10px",
                background: "var(--bg-card)",
              }}
            >
              <div className="mb-3 text-muted">
                Drag & drop PDF here or click browse
              </div>

              <Form.Control
                ref={inputRef}
                type="file"
                accept="application/pdf"
                onChange={onFileSelect}
                aria-label="Upload brochure"
              />

              {file && (
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <strong>{file.name}</strong>
                    <div className="text-muted small">
                      {humanFileSize(file.size)}
                    </div>
                  </div>
                  <div>
                    <Button
                      variant="outline-primary"
                      className="me-2"
                      onClick={() => setFile(null)}
                      disabled={uploading}
                    >
                      Clear
                    </Button>
                    <Button
                      onClick={handleUpload}
                      disabled={uploading}
                      className="btn-custom"
                    >
                      {uploading ? "Uploading..." : "Upload"}
                    </Button>
                  </div>
                </div>
              )}

              {uploading && (
                <div className="mt-3">
                  <ProgressBar now={progress} label={`${progress}%`} />
                </div>
              )}
            </div>

            <div className="mt-3">
              <small className="text-muted">
                Max file size: 10 MB. Only PDF allowed.
              </small>
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Brochure;